import { render, staticRenderFns } from "./MspConfirm.vue?vue&type=template&id=0b81aea4"
import script from "./MspConfirm.vue?vue&type=script&lang=js"
export * from "./MspConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports